export default {
	tooLongDescriptionError: "El campo \"{0}\" no puede tener más de 255 caracteres.",
	fieldIsRequiredError: "El campo \"{0}\" es obligatorio.",
	retypePasswordError: "Contraseña reescrita incorrecta.",

	permissionLevelRequiredError: "El campo \"Nivel de autorización \" es obligatorio.",
	addToIssue: "Agregar a la emisión",
	dataSets: "Conjuntos de datos",
	businessProcesses: "Procesos de negocios",
	resource: "Recurso",
	period: "Período",
	authorizationLevel: "Nivel de autorización",
	currentAuthorizations: "Autorizaciones vigentes",

	warningEmployeeChangeTitle: "Cambio de usuario con el que se relaciona la aplicación",
	warningEmployeeChangeText: "¿Está seguro de que desea cambiar a {0}? Se eliminará todo el alcance.",
	selectEmployee: "Seleccionar empleado",
	authorizationControlHasChanges: "El control de autorización ha complementado datos sobre el alcance de la aplicación, que no se ha agregado.",

	editing: "Edición",
	copying: "Proceso de copiar",
	copy: "Dupdo",
	accept: "Aceptar",
	reject: "Rechazar",

	selectApplication: "Seleccionar aplicación",
	selectService: "Seleccionar servicio",
	selectDataSet: "Seleccionar conjunto de datos",
	selectBusinessProcess: "Seleccionar proceso empresarial",

	name: "Nombre",
	sapId: "SAP Id",
	hrId: "HR Id",
	applicationName: "Nombre de la aplicación",
	type: "Escribe",
	status: "Estado",
	city: "Ciudad",
	company: "Empresa",
	riskLevel: "Nivel de riesgo",
	department: "Departamento",

	administrativeRole: "Rol administrativo",
	sensitiveData: "Informacion delicada",
	reasonForProcessingSensitiveData: "El motivo del tratamiento de datos sensibles",
	acceptCheckboxLabel: "He leído y entendido el texto anterior.",

	step: "Paso",
	of: "de",
}